<template>
  <div class="launch-product">
    <div class="content">
      <div class="icon" v-if="!isSkip">
        <i class="iconfont icon-icon-feiloukong"></i>
      </div>
      <div v-if="!isSkip">
        <p v-if="$route.query.certification">
          【{{ accessData ? accessData.authCompName : '' }}】企业实名认证已完成
        </p>
        <p v-else>恭喜您完成企业实名认证</p>
      </div>
      <p>开通体验智工嗨搜产品功能吧！</p>

      <div class="consent-agreement">
        <el-checkbox
          v-if="rnewCheckBox"
          @change="checkboxChange"
          :value="checked"
        ></el-checkbox>
        <span>我已阅读并同意</span>
        <b
          v-for="(item, index) in agreements"
          @click="agreementClick(item, index)"
          :key="item.name"
          >《{{ item.name }}》{{ index + 1 < agreements.length ? '、' : '' }}</b
        >
      </div>

      <el-button type="primary" :disabled="!checked" @click="submit" :loading="btnLoading"
        >开通使用</el-button
      >
    </div>
    <ServiceAgreement
      ref="orderSubmissionServiceAgreement"
      v-if="serviceAgreementShow"
      @close="serviceAgreementClose"
      :agreements="agreements"
      :index="agreementIndex"
    />
  </div>
</template>

<script>
import ServiceAgreement from '@/components/common/ServiceAgreement'
import { setOrderProductTrial } from '@/utils/api/permission-verification'
import { mapState, mapMutations, mapActions } from 'vuex'
import getAgreementMinxins from '@/mixins/getAgreement'
export default {
  components: {
    ServiceAgreement,
  },
  mixins: [getAgreementMinxins],
  computed: {
    ...mapState('permissionVerification', ['accessData']),
    ...mapState('serviceAgreement', ['agreementList']),
    ...mapState(['userInfo']),
    isSkip() {
      const status = this.accessData?.accessPermission || null
      return status === 2 || status === 3
    }
  },
  watch: {
    accessData: {
      // 查询是否是应该走激活这一步，如果存在越过其他步骤的情况，直接带到引导页
      handler(newVal) {
        if (!newVal) return
        if (newVal.accessPermission === 1 || newVal.accessPermission === 5) {
          // 如果 已认证 已激活 去功能页
          this.$router.push({
            name: this.$route.query.to || 'dashboard',
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      checked: false,
      serviceAgreementShow: false,
      consentTime: null,
      agreements: [],
      rnewCheckBox: true,
      agreementIndex: undefined,
      btnLoading: false,
    }
  },
  methods: {
    ...mapMutations('permissionVerification', ['SET_ACCESS_DATA']),
    ...mapMutations('serviceAgreement', ['SET_AGREEMENT_LIST']),
    ...mapActions('permissionVerification', ['requestAccessData']),

    async submit() {
      this.btnLoading = true
      const _remark = this.userInfo.leadsStatus != 8 ? 
        '海智铂金会员，钻石会员，VIP会员，VVIP会员限时特惠' :
        '海智老朋友限时体验价'
      try {
        const res = await setOrderProductTrial({
          remark: _remark,
          agreements: this.agreements.map((ele) => {
            return {
              agreementType: ele.type,
              agreementName: ele.name,
              version: ele.version,
              agreeTime: this.consentTime,
              agreementUrl: ele.url,
            }
          }),
        })
        if (res.rspResult.bizCode === 200) {
          // 重新请求认证信息
          await this.requestAccessData()
        } else if(res.rspResult.bizCode === 5130) {
          // 重新请求认证信息
          await this.requestAccessData()
        } else {
          this.$message.error(res.rspResult.message)
        }
      } catch (err) {
        console.error("❌ ~ file: launch-product.vue:139 ~ submit ~ err:", err)
      } finally {
        this.btnLoading = false
      }
    },
  },
  created() {
    this.getAgreementList()
  },
}
</script>

<style lang="scss" scoped>
.launch-product {
  background-color: #f3f5f8;
  height: calc(100vh - 96px);
  padding-top: 50px;
  box-sizing: border-box;
  > .content {
    width: 1040px;
    margin: 0 auto;
    background-color: #fff;
    padding: 0 80px;
    padding-top: 30px;
    padding-bottom: 100px;
    box-sizing: border-box;
    text-align: center;
    padding-top: 184px;
    p {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #16181a;
      letter-spacing: 0;
    }
    .el-button {
      width: 220px;
      height: 40px;
    }
    .is-disabled {
      background: #cfd5df;
      color: #ffffff;
      border: none;
    }
    .consent-agreement {
      margin-top: 61px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 12px;
      color: #16181a;
      margin-bottom: 23px;
      > span {
        margin-left: 10px;
      }
      > b {
        cursor: pointer;
        color: #066eb7;
        font-weight: normal;
      }
    }
    .icon {
      margin: 0 auto 20px;
      width: 30px;
      height: 30px;
      background-color: #0bb976;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 46px;
        color: #e6f8f1;
      }
    }
  }
}
</style>
